import { HamburgerIcon } from "@chakra-ui/icons"
import { Box, Container, Flex, Grid, IconButton, Image, Link } from "@chakra-ui/react"
import { Link as BlitzLink, Routes } from "blitz"
import React, { FC } from "react"
import { useTranslation } from "react-i18next"

import { useAuthContext } from "../../../utils/misc/AuthContext"
import { EnvironmentIndicator } from "../../components/EnvironmentIndicator"
import { HEADER_HEIGHT } from "../../config/constants"

interface Props {
  onClickHamburger: () => void
}

export const headerLinkProps = {
  _hover: { textDecoration: "none", background: "expertBlue.700" },
  h: `${HEADER_HEIGHT}px`,
  px: 2,
}

const Header: FC<Props> = ({ onClickHamburger }) => {
  const { t } = useTranslation()
  const { currentUser } = useAuthContext()

  return (
    <Box
      as="header"
      h={`${HEADER_HEIGHT}px`}
      background="brand.expertBlue"
      color="white"
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={10}
    >
      <Grid templateColumns="repeat(3, 1fr)">
        <Box display={["block", null, "none"]} />

        <Flex alignItems="center" justifyContent={["center", null, "flex-start"]}>
          <BlitzLink href={Routes.Dashboard()} passHref>
            <Link display="flex" alignItems="center" position="relative" {...headerLinkProps}>
              <Flex alignItems="center">
                <Box ml={"12px"}>
                  <Image
                    src="/images/arcensus-logo_monochrome-white.svg"
                    alt="arcensus"
                    width="190px"
                  />
                </Box>
              </Flex>
              <EnvironmentIndicator bottom={0} left={20} />
            </Link>
          </BlitzLink>
        </Flex>

        <Container display="flex" alignItems="center" justifyContent="flex-end">
          <IconButton
            aria-label={t("actions.openMenu")}
            size="lg"
            variant={"ghost"}
            icon={<HamburgerIcon />}
            display={["block", "block", "none"]}
            onClick={onClickHamburger}
          />
        </Container>
      </Grid>
    </Box>
  )
}

export default Header
